const locale = {
  placeholder: '输入 IP 地址',
  errorMsg: {
    INVALID: 'IP 格式错误。请输入正确的 IP。',
    INVALID_SUBNET: 'IP 不在子网网段内，请输入 {{subnet}} 网段内的 IP。',
    INVALID_IPV4: 'IP 格式错误。请输入正确的 IP。',
    // deprecated
    INVALID_IPV6: 'IP 格式错误。请输入正确的 IP。',
    // deprecated
    IPV4_NOT_IN_SUBNET: 'IP 不在子网网段内，请输入 {{subnet}} 网段内的 IP。',
    // deprecated
    IPV6_NOT_IN_SUBNET: 'IP 不在子网网段内，请输入 {{subnet}} 网段内的 IP。',
    // deprecated
    EXCLUDES: 'IP 已被占用，请输入可用 IP。',
    EXISTS: '重复的 IP。请输入可用 IP。'
  },
  recommend: '推荐：'
};
export default locale;